import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const CommunityPhotos = () => {
  const { lang } = useLanguage();

  const texts = {
    de: { title: 'Unsere Gemeinde', subtitle: 'Echte Momente aus unserem Gemeindeleben', pastor: 'Unser Pastor', worship: 'Lobpreis im Gottesdienst', service: 'Sonntagsgottesdienst', baptism: 'Taufe' },
    en: { title: 'Our Community', subtitle: 'Real moments from our church life', pastor: 'Our Pastor', worship: 'Worship Service', service: 'Sunday Service', baptism: 'Baptism' },
    fr: { title: 'Notre Communaute', subtitle: 'De vrais moments de notre vie communautaire', pastor: 'Notre Pasteur', worship: 'Louange', service: 'Culte du dimanche', baptism: 'Bapteme' },
  };
  const t = texts[lang] || texts.de;

  const photos = [
    {
      src: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/d627051975e093c2_image.png',
      alt: t.pastor,
      label: t.pastor,
      span: 'col-span-2 row-span-2',
    },
    {
      src: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/304e54fc525d214e_image.png',
      alt: t.worship,
      label: t.worship,
      span: 'col-span-2',
    },
    {
      src: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/1e19e7ea55535902_image.png',
      alt: t.service,
      label: t.service,
      span: '',
    },
    {
      src: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/863352a9eadc165f_image.png',
      alt: t.service,
      label: t.service,
      span: '',
    },
    {
      src: 'https://customer-assets-v7afamib.emergentagent.net/job_19aead6b-8655-4d59-bd82-6868e26d577e/artifacts/53700a6b80022090_image.png',
      alt: t.baptism,
      label: t.baptism,
      span: 'col-span-2',
    },
  ];

  return (
    <section className="py-20 bg-white" data-testid="community-photos-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">{t.title}</h2>
          <div className="w-20 h-1 bg-[#0f2440] mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">{t.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 max-w-5xl mx-auto">
          {photos.map((photo) => (
            <div
              key={photo.src}
              className={`${photo.span} relative group rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300`}
              data-testid={`community-photo-${photo.src}`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover min-h-[180px] md:min-h-[220px] group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <span className="text-white text-sm font-semibold drop-shadow-lg">{photo.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityPhotos;
